import Carousel from '../../shared/Carousel/Carousel';
import { resolveImageUrl, type ImageFieldValue } from '../../../helpers/blocks';

export type SlideItem = {
  image?: ImageFieldValue;
  alt?: string;
  caption?: string;
};

export type MediaCarouselData = {
  slides?: SlideItem[];
  autoplay?: boolean;
  showDots?: boolean;
};

const MediaCarouselView = ({ data }: { data: MediaCarouselData }) => {
  const slides = data.slides || [];

  const nodes = slides
    .map((slide) => ({ slide, imageUrl: resolveImageUrl(slide.image) }))
    .filter((entry) => !!entry.imageUrl)
    .map((entry, i) => (
      <figure className="media-carousel__slide" key={i}>
        <img
          src={entry.imageUrl}
          alt={entry.slide.alt || ''}
          loading={i === 0 ? undefined : 'lazy'}
        />
        {entry.slide.caption && (
          <figcaption className="media-carousel__caption">
            {entry.slide.caption}
          </figcaption>
        )}
      </figure>
    ));

  if (nodes.length === 0) return null;

  return (
    <div className="block-media-carousel">
      <Carousel
        slides={nodes}
        autoplay={data.autoplay}
        showDots={data.showDots !== false}
        variant="on-light"
      />
    </div>
  );
};

export default MediaCarouselView;
